// ----------------------------------------------------------------------

const bulkmail = [
  {
    id: 1,
    name: 'zxc',
    email: 'zxc@zxc.zxc'
  },
  {
    id: 2,
    name: 'qwe qwe',
    email: 'qwe@qwe.qwe'
  },
  {
    id: 3,
    name: 'asd asd',
    email: 'asd@asd.asd'
  }
];

export default bulkmail;
